import { render, staticRenderFns } from "./apply_withdrawal.vue?vue&type=template&id=244e2220&scoped=true&"
import script from "./apply_withdrawal.vue?vue&type=script&lang=js&"
export * from "./apply_withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./apply_withdrawal.vue?vue&type=style&index=0&id=244e2220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e2220",
  null
  
)

export default component.exports